import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const createPartRFQ = createAsyncThunk(
    'procurement/createPartRFQ',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.createPartRFQ(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to create RFQ');
        }
    }
);

export const fetchRFQsPaginated = createAsyncThunk(
    'procurement/fetchRFQsPaginated',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getRFQsPaginated(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch RFQs');
        }
    }
);

export const fetchRFQOverview = createAsyncThunk(
    'procurement/fetchRFQOverview',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getRFQOverview();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch RFQ overview');
        }
    }
);

export const fetchRFQDetail = createAsyncThunk(
    'procurement/fetchRFQDetail',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.getRFQDetail(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch RFQ detail');
        }
    }
);

export const updatePartRFQ = createAsyncThunk(
    'procurement/updatePartRFQ',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updatePartRFQ(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update RFQ');
        }
    }
);

export const getRFQHistory = createAsyncThunk(
    'procurement/getRFQHistory',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getRFQHistory(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch RFQ history');
        }
    }
);

export const commentOnRFQ = createAsyncThunk(
    'procurement/commentOnRFQ',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.commentOnRFQ(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to comment on RFQ');
        }
    }
);

export const updatePartRFQStatus = createAsyncThunk(
    'procurement/updatePartRFQStatus',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updatePartRFQStatus(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update RFQ status');
        }
    }
);

export const resendRfq = createAsyncThunk(
    'procurement/resendRfq',
    async (partRfqId, { rejectWithValue }) => {
        try {
            const response = await apiService.resendRfq(partRfqId);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to resend RFQ');
        }
    }
);

export const deletePartRFQ = createAsyncThunk(
    'procurement/deletePartRFQ',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.deletePartRFQ(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to delete RFQ');
        }
    }
);

export const updateSupplyChainStatus = createAsyncThunk(
    'procurement/updateSupplyChainStatus',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updateSupplyChainStatus(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update supply chain status');
        }
    }
);

export const createPurchaseOrder = createAsyncThunk(
    'procurement/createPurchaseOrder',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.createPurchaseOrder(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to generate PO');
        }
    }
);

export const getRFQBidsPaginated = createAsyncThunk(
    'procurement/getRFQBidsPaginated',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getRFQBidsPaginated(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Bids');
        }
    }
);

export const fetchPurchaseOrdersPaginated = createAsyncThunk(
    'procurement/fetchPurchaseOrdersPaginated',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getPurchaseOrdersPaginated(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Purchase Orders');
        }
    }
);

export const fetchPurchaseOrdersOverview = createAsyncThunk(
    'procurement/fetchPurchaseOrdersOverview',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getPurchaseOrdersOverview();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Purchase Orders overview');
        }
    }
);

export const fetchPurchaseOrderDetail = createAsyncThunk(
    'procurement/fetchPurchaseOrderDetail',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.getPurchaseOrderDetail(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch PO detail');
        }
    }
);

export const fetchPurchaseOrderFinanceDetail = createAsyncThunk(
    'procurement/fetchPurchaseOrderFinanceDetail',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.getPurchaseOrderFinanceDetail(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch PO finance detail');
        }
    }
);

export const updatePurchaseOrderGeneralDetail = createAsyncThunk(
    'procurement/updatePurchaseOrderGeneralDetail',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updatePurchaseOrderGeneralDetail(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update PO general details');
        }
    }
);

export const updatePurchaseOrderVerification = createAsyncThunk(
    'procurement/updatePurchaseOrderVerification',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updatePurchaseOrderVerification(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update PO verification details');
        }
    }
);

export const updatePurchaseOrderPaymentTransactions = createAsyncThunk(
    'procurement/updatePurchaseOrderPaymentTransactions',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updatePurchaseOrderPaymentTransactions(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update PO payment transactions');
        }
    }
);

export const deletePurchaseOrderPaymentTransaction = createAsyncThunk(
    'procurement/deletePurchaseOrderPaymentTransaction',
    async (transactionId, { rejectWithValue }) => {
        try {
            const response = await apiService.deletePurchaseOrderPaymentTransaction(transactionId);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to delete PO payment transaction');
        }
    }
);

export const deletePurchaseOrder = createAsyncThunk(
    'procurement/deletePurchaseOrder',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.deletePurchaseOrder(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to delete Purchase Order');
        }
    }
);

const initialState = {
    createPartRFQLoading: false,
    createPartRFQError: null,
    getRFQsPaginated: null,
    getRFQsLoading: false,
    getRFQsError: null,
    getRFQOverviewData: null,
    getRFQOverviewLoading: false,
    getRFQOverviewError: null,
    rfqDetail: null,
    rfqDetailLoading: false,
    rfqDetailError: null,
    updatePartRFQLoading: false,
    updatePartRFQError: null,
    getRFQHistoryData: null,
    getRFQHistoryLoading: false,
    getRFQHistoryError: null,
    commentOnRFQLoading: false,
    commentOnRFQError: null,
    updatePartRFQStatusLoading: false,
    updatePartRFQStatusError: null,
    resendRfqLoading: false,
    resendRfqError: null,
    deletePartRFQLoading: false,
    deletePartRFQError: null,
    updateSupplyChainStatusLoading: false,
    updateSupplyChainStatusError: null,
    createPurchaseOrderLoading: false,
    createPurchaseOrderError: null,
    getPurchaseOrdersPaginated: null,
    getPurchaseOrdersLoading: false,
    getPurchaseOrdersError: null,
    getPurchaseOrdersOverviewData: null,
    getPurchaseOrdersOverviewLoading: false,
    getPurchaseOrdersOverviewError: null,
    getRFQBidsPaginated: null,
    getRFQBidsLoading: false,
    getRFQBidsError: null,
    poDetail: null,
    poDetailLoading: false,
    poDetailError: null,
    poFinanceDetail: null,
    poFinanceDetailLoading: false,
    poFinanceDetailError: null,
    updatePurchaseOrderGeneralDetailLoading: false,
    updatePurchaseOrderGeneralDetailError: null,
    updatePurchaseOrderVerificationLoading: false,
    updatePurchaseOrderVerificationError: null,
    updatePurchaseOrderPaymentTransactionsLoading: false,
    updatePurchaseOrderPaymentTransactionsError: null,
    deletePurchaseOrderPaymentTransactionLoading: false,
    deletePurchaseOrderPaymentTransactionError: null,
    deletePurchaseOrderLoading: false,
    deletePurchaseOrderError: null,
    rfqState: {
        page: 1,
        limit: 10,
        searchTerm: '',
        searchFilters: {}
    },
    poState: {
        page: 1,
        limit: 10,
        searchTerm: '',
        searchFilters: {}
    }
};

const ProcurementSlice = createSlice({
    name: 'procurement',
    initialState,
    reducers: {
        updateRFQStatusReducer: (state, action) => {
            const { id, status } = action.payload;
            if (state.getRFQsPaginated?.results) {
                const rfq = state.getRFQsPaginated.results.find((item) => item.id === id);
                if (rfq) {
                    rfq.status = status;
                }
            }
        },
        updateRFQSupplyChainStatusReducer: (state, action) => {
            const { id, supply_chain_status } = action.payload;
            if (state.getRFQsPaginated?.results) {
                const rfq = state.getRFQsPaginated.results.find((item) => item.id === id);
                if (rfq) {
                    rfq.supply_chain_status = supply_chain_status;
                }
            }
        },
        setRfqState: (state, action) => {
            state.rfqState = { ...state.rfqState, ...action.payload };
        },
        setPoState: (state, action) => {
            state.poState = { ...state.poState, ...action.payload };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createPartRFQ.pending, (state) => {
                state.createPartRFQLoading = true;
                state.createPartRFQError = null;
            })
            .addCase(createPartRFQ.fulfilled, (state) => {
                state.createPartRFQLoading = false;
                state.createPartRFQError = null;
            })
            .addCase(createPartRFQ.rejected, (state, action) => {
                state.createPartRFQLoading = false;
                state.createPartRFQError = action.payload;
            })
            .addCase(fetchRFQsPaginated.pending, (state) => {
                state.getRFQsLoading = true;
                state.getRFQsError = null;
            })
            .addCase(fetchRFQsPaginated.fulfilled, (state, action) => {
                state.getRFQsLoading = false;
                state.getRFQsPaginated = action.payload?.data;
                state.getRFQsError = null;
            })
            .addCase(fetchRFQsPaginated.rejected, (state, action) => {
                state.getRFQsLoading = false;
                state.getRFQsError = action.payload;
            })
            .addCase(fetchRFQOverview.pending, (state) => {
                state.getRFQOverviewLoading = true;
                state.getRFQOverviewError = null;
            })
            .addCase(fetchRFQOverview.fulfilled, (state, action) => {
                state.getRFQOverviewLoading = false;
                state.getRFQOverviewData = action.payload?.data;
                state.getRFQOverviewError = null;
            })
            .addCase(fetchRFQOverview.rejected, (state, action) => {
                state.getRFQOverviewLoading = false;
                state.getRFQOverviewError = action.payload;
            })
            .addCase(fetchRFQDetail.pending, (state) => {
                state.rfqDetailLoading = true;
                state.rfqDetailError = null;
            })
            .addCase(fetchRFQDetail.fulfilled, (state, action) => {
                state.rfqDetailLoading = false;
                state.rfqDetail = action.payload?.data;
                state.rfqDetailError = null;
            })
            .addCase(fetchRFQDetail.rejected, (state, action) => {
                state.rfqDetailLoading = false;
                state.rfqDetailError = action.payload;
            })
            .addCase(updatePartRFQ.pending, (state) => {
                state.updatePartRFQLoading = true;
                state.updatePartRFQError = null;
            })
            .addCase(updatePartRFQ.fulfilled, (state, action) => {
                state.updatePartRFQLoading = false;
                state.updatePartRFQError = null;
            })
            .addCase(updatePartRFQ.rejected, (state, action) => {
                state.updatePartRFQLoading = false;
                state.updatePartRFQError = action.payload;
            })
            .addCase(getRFQHistory.pending, (state) => {
                state.getRFQHistoryLoading = true;
                state.getRFQHistoryError = null;
            })
            .addCase(getRFQHistory.fulfilled, (state, action) => {
                state.getRFQHistoryLoading = false;
                state.getRFQHistoryData = action.payload?.data;
                state.getRFQHistoryError = null;
            })
            .addCase(getRFQHistory.rejected, (state, action) => {
                state.getRFQHistoryLoading = false;
                state.getRFQHistoryError = action.payload;
            })
            .addCase(commentOnRFQ.pending, (state) => {
                state.commentOnRFQLoading = true;
                state.commentOnRFQError = null;
            })
            .addCase(commentOnRFQ.fulfilled, (state) => {
                state.commentOnRFQLoading = false;
                state.commentOnRFQError = null;
            })
            .addCase(commentOnRFQ.rejected, (state, action) => {
                state.commentOnRFQLoading = false;
                state.commentOnRFQError = action.payload;
            })
            .addCase(updatePartRFQStatus.pending, (state) => {
                state.updatePartRFQStatusLoading = true;
                state.updatePartRFQStatusError = null;
            })
            .addCase(updatePartRFQStatus.fulfilled, (state) => {
                state.updatePartRFQStatusLoading = false;
                state.updatePartRFQStatusError = null;
            })
            .addCase(updatePartRFQStatus.rejected, (state, action) => {
                state.updatePartRFQStatusLoading = false;
                state.updatePartRFQStatusError = action.payload;
            })
            .addCase(resendRfq.pending, (state) => {
                state.resendRfqLoading = true;
                state.resendRfqError = null;
            })
            .addCase(resendRfq.fulfilled, (state) => {
                state.resendRfqLoading = false;
                state.resendRfqError = null;
            })
            .addCase(resendRfq.rejected, (state, action) => {
                state.resendRfqLoading = false;
                state.resendRfqError = action.payload;
            })
            .addCase(deletePartRFQ.pending, (state) => {
                state.deletePartRFQLoading = true;
                state.deletePartRFQError = null;
            })
            .addCase(deletePartRFQ.fulfilled, (state) => {
                state.deletePartRFQLoading = false;
                state.deletePartRFQError = null;
            })
            .addCase(deletePartRFQ.rejected, (state, action) => {
                state.deletePartRFQLoading = false;
                state.deletePartRFQError = action.payload;
            })
            .addCase(updateSupplyChainStatus.pending, (state) => {
                state.updateSupplyChainStatusLoading = true;
                state.updateSupplyChainStatusError = null;
            })
            .addCase(updateSupplyChainStatus.fulfilled, (state) => {
                state.updateSupplyChainStatusLoading = false;
                state.updateSupplyChainStatusError = null;
            })
            .addCase(updateSupplyChainStatus.rejected, (state, action) => {
                state.updateSupplyChainStatusLoading = false;
                state.updateSupplyChainStatusError = action.payload;
            })
            .addCase(createPurchaseOrder.pending, (state) => {
                state.createPurchaseOrderLoading = true;
                state.createPurchaseOrderError = null;
            })
            .addCase(createPurchaseOrder.fulfilled, (state) => {
                state.createPurchaseOrderLoading = false;
                state.createPurchaseOrderError = null;
            })
            .addCase(createPurchaseOrder.rejected, (state, action) => {
                state.createPurchaseOrderLoading = false;
                state.createPurchaseOrderError = action.payload;
            })
            .addCase(getRFQBidsPaginated.pending, (state) => {
                state.getRFQBidsLoading = true;
                state.getRFQBidsError = null;
            })
            .addCase(getRFQBidsPaginated.fulfilled, (state, action) => {
                state.getRFQBidsLoading = false;
                state.getRFQBidsPaginated = action.payload?.data;
                state.getRFQBidsError = null;
            })
            .addCase(getRFQBidsPaginated.rejected, (state, action) => {
                state.getRFQBidsLoading = false;
                state.getRFQBidsError = action.payload;
            })
            .addCase(fetchPurchaseOrdersPaginated.pending, (state) => {
                state.getPurchaseOrdersLoading = true;
                state.getPurchaseOrdersError = null;
            })
            .addCase(fetchPurchaseOrdersPaginated.fulfilled, (state, action) => {
                state.getPurchaseOrdersLoading = false;
                state.getPurchaseOrdersPaginated = action.payload?.data;
                state.getPurchaseOrdersError = null;
            })
            .addCase(fetchPurchaseOrdersPaginated.rejected, (state, action) => {
                state.getPurchaseOrdersLoading = false;
                state.getPurchaseOrdersError = action.payload;
            })
            .addCase(fetchPurchaseOrdersOverview.pending, (state) => {
                state.getPurchaseOrdersOverviewLoading = true;
                state.getPurchaseOrdersOverviewError = null;
            })
            .addCase(fetchPurchaseOrdersOverview.fulfilled, (state, action) => {
                state.getPurchaseOrdersOverviewLoading = false;
                state.getPurchaseOrdersOverviewData = action.payload?.data;
                state.getPurchaseOrdersOverviewError = null;
            })
            .addCase(fetchPurchaseOrdersOverview.rejected, (state, action) => {
                state.getPurchaseOrdersOverviewLoading = false;
                state.getPurchaseOrdersOverviewError = action.payload;
            })
            .addCase(fetchPurchaseOrderDetail.pending, (state) => {
                state.poDetailLoading = true;
                state.poDetailError = null;
            })
            .addCase(fetchPurchaseOrderDetail.fulfilled, (state, action) => {
                state.poDetailLoading = false;
                state.poDetail = action.payload?.data;
                state.poDetailError = null;
            })
            .addCase(fetchPurchaseOrderDetail.rejected, (state, action) => {
                state.poDetailLoading = false;
                state.poDetailError = action.payload;
            })
            .addCase(fetchPurchaseOrderFinanceDetail.pending, (state) => {
                state.poFinanceDetailLoading = true;
                state.poFinanceDetailError = null;
            })
            .addCase(fetchPurchaseOrderFinanceDetail.fulfilled, (state, action) => {
                state.poFinanceDetailLoading = false;
                state.poFinanceDetail = action.payload?.data;
                state.poFinanceDetailError = null;
            })
            .addCase(fetchPurchaseOrderFinanceDetail.rejected, (state, action) => {
                state.poFinanceDetailLoading = false;
                state.poFinanceDetailError = action.payload;
            })
            .addCase(updatePurchaseOrderGeneralDetail.pending, (state) => {
                state.updatePurchaseOrderGeneralDetailLoading = true;
                state.updatePurchaseOrderGeneralDetailError = null;
            })
            .addCase(updatePurchaseOrderGeneralDetail.fulfilled, (state, action) => {
                state.updatePurchaseOrderGeneralDetailLoading = false;
                state.updatePurchaseOrderGeneralDetailError = null;
                if (state.poDetail) {
                    state.poDetail.notes = action.payload?.data?.notes ?? state.poDetail.notes;
                }
            })
            .addCase(updatePurchaseOrderGeneralDetail.rejected, (state, action) => {
                state.updatePurchaseOrderGeneralDetailLoading = false;
                state.updatePurchaseOrderGeneralDetailError = action.payload;
            })
            .addCase(updatePurchaseOrderVerification.pending, (state) => {
                state.updatePurchaseOrderVerificationLoading = true;
                state.updatePurchaseOrderVerificationError = null;
            })
            .addCase(updatePurchaseOrderVerification.fulfilled, (state, action) => {
                state.updatePurchaseOrderVerificationLoading = false;
                state.updatePurchaseOrderVerificationError = null;
                if (state.poDetail) {
                    state.poDetail.receiving_notes = action.payload?.data?.receiving_notes ?? state.poDetail.receiving_notes;
                    state.poDetail.notes = action.payload?.data?.notes ?? state.poDetail.notes;
                }
            })
            .addCase(updatePurchaseOrderVerification.rejected, (state, action) => {
                state.updatePurchaseOrderVerificationLoading = false;
                state.updatePurchaseOrderVerificationError = action.payload;
            })
            .addCase(updatePurchaseOrderPaymentTransactions.pending, (state) => {
                state.updatePurchaseOrderPaymentTransactionsLoading = true;
                state.updatePurchaseOrderPaymentTransactionsError = null;
            })
            .addCase(updatePurchaseOrderPaymentTransactions.fulfilled, (state) => {
                state.updatePurchaseOrderPaymentTransactionsLoading = false;
                state.updatePurchaseOrderPaymentTransactionsError = null;
            })
            .addCase(updatePurchaseOrderPaymentTransactions.rejected, (state, action) => {
                state.updatePurchaseOrderPaymentTransactionsLoading = false;
                state.updatePurchaseOrderPaymentTransactionsError = action.payload;
            })
            .addCase(deletePurchaseOrderPaymentTransaction.pending, (state) => {
                state.deletePurchaseOrderPaymentTransactionLoading = true;
                state.deletePurchaseOrderPaymentTransactionError = null;
            })
            .addCase(deletePurchaseOrderPaymentTransaction.fulfilled, (state) => {
                state.deletePurchaseOrderPaymentTransactionLoading = false;
                state.deletePurchaseOrderPaymentTransactionError = null;
            })
            .addCase(deletePurchaseOrderPaymentTransaction.rejected, (state, action) => {
                state.deletePurchaseOrderPaymentTransactionLoading = false;
                state.deletePurchaseOrderPaymentTransactionError = action.payload;
            })
            .addCase(deletePurchaseOrder.pending, (state) => {
                state.deletePurchaseOrderLoading = true;
                state.deletePurchaseOrderError = null;
            })
            .addCase(deletePurchaseOrder.fulfilled, (state) => {
                state.deletePurchaseOrderLoading = false;
                state.deletePurchaseOrderError = null;
            })
            .addCase(deletePurchaseOrder.rejected, (state, action) => {
                state.deletePurchaseOrderLoading = false;
                state.deletePurchaseOrderError = action.payload;
            });
    },
});

export const { updateRFQStatusReducer, updateRFQSupplyChainStatusReducer, setRfqState, setPoState } = ProcurementSlice.actions;

export default ProcurementSlice.reducer;
